import update from 'immutability-helper';
import { PublicReduxAction } from './Action';

export interface PublicState {
  accessToken: string;
  refreshToken: string;
  isUserLoggedIn: boolean;
  orgName?: string;
}

export const publicState: PublicState = {
  isUserLoggedIn: false,
  accessToken: '',
  refreshToken: '',
  orgName: '',
};

const PublicAuthStateReducer = (
  state = publicState,
  action: any = { type: '', payload: {} }
): PublicState => {
  switch (action.type) {
    case PublicReduxAction.PUBLIC_AUTH_SET_LOGIN_STATUS:
      return update(state, {
        $merge: {
          ...action.payload,
        },
      });
    default:
      return publicState;
  }
};

export default PublicAuthStateReducer;
